export interface ITokens {
  cat: string;
  token?: string;
}
